<template>
<div class="card">
    <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="true">
    </loading>
    <div class="card-header">
        <p class="card-header-title">Add Notification</p>
    </div>
    <div class="card-content">

        <div class="field">
            <div class="columns">
                <div class="column is-full">
                    <b-radio v-model="notificationType" native-value="1">
                        To teacher/supervisor via QR Points app
                    </b-radio>
                    <b-radio v-model="notificationType" native-value="2">
                        To students/parents/staff via QR Points Monitoring app
                    </b-radio>
                </div>
            </div>
        </div>
        <div v-show="notificationType==1">                
            <div class="columns">
                <div class="column is-full">
                    <input class="input is-success" type="text" placeholder="Title" v-model="title">
                </div>
            </div>
            <div class="columns">
                <div class="column is-full">
                    <input class="input" type="text" placeholder="Message" v-model="message">
                </div>
            </div>
            <div class="columns">
                <div class="column is-2">
                    Send now?
                </div>
                <div class="column">
                    <b-radio v-model="sendNow" native-value="1">
                        Yes, send notification now
                    </b-radio>
                    <b-radio v-model="sendNow" native-value="0">
                        No, send according to the time &amp; day below.
                    </b-radio>
                </div>
            </div>
            <div v-show="sendNow != 1">
                <div class="columns">
                    <div class="column is-2">
                        Repeat on:
                    </div>
                    <div class="column">
                        <input type="checkbox" id="1" value="1" v-model="repeatOn"><label for="1">&nbsp;Monday</label>
                    </div>
                    <div class="column">
                        <input type="checkbox" id="2" value="2" v-model="repeatOn"><label for="2">&nbsp;Tuesday</label>
                    </div>
                    <div class="column">
                        <input type="checkbox" id="3" value="3" v-model="repeatOn"><label for="3">&nbsp;Wednesday</label>
                    </div>
                    <div class="column">
                        <input type="checkbox" id="4" value="4" v-model="repeatOn"><label for="4">&nbsp;Thursday</label>
                    </div>
                    <div class="column">
                        <input type="checkbox" id="5" value="5" v-model="repeatOn"><label for="5">&nbsp;Friday</label>
                    </div>
                    <div class="column">
                        <input type="checkbox" id="6" value="6" v-model="repeatOn"><label for="6">&nbsp;Saturday</label>
                    </div>
                    <div class="column">
                        <input type="checkbox" id="0" value="0" v-model="repeatOn"><label for="0">&nbsp;Sunday</label>
                    </div>
                </div>
                <div class="columns">
                    <div class="column is-2">Time:</div>                    
                    <div class="column">
                        <b-select id="repeatTime" name="repeatTime" v-model="repeatTime">
                            <option selected value="7">7 a.m.</option>
                            <option value="8">8 a.m.</option>
                            <option value="9">9 a.m.</option>
                            <option value="10">10 a.m.</option>
                            <option value="11">11 a.m.</option>
                            <option value="12">12 p.m.</option>
                            <option value="13">1 p.m.</option>
                            <option value="14">2 p.m.</option>
                            <option value="15">3 p.m.</option>
                            <option value="16">4 p.m.</option>
                            <option value="17">5 p.m.</option>
                            <option value="18">6 p.m.</option>
                            <option value="19">7 p.m.</option>
                            <option value="20">8 p.m.</option>
                            <option value="21">9 p.m.</option>
                            <option value="22">10 p.m.</option>
                            <option value="23">11 p.m.</option>
                            <option value="0">12 a.m.</option>
                            <option value="1">1 a.m.</option>
                            <option value="2">2 a.m.</option>
                            <option value="3">3 a.m.</option>
                            <option value="4">4 a.m.</option>
                            <option value="5">5 a.m.</option>
                            <option value="6">6 a.m.</option>
                        </b-select>
                    </div>
                </div>
                <div class="columns">
                    <div class="column is-2">
                        Status:
                    </div>
                    <div class="column">                        
                        <b-radio v-model="status" native-value="1">
                            Active
                        </b-radio>
                        <b-radio v-model="status" native-value="0">
                            Inactive
                        </b-radio>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="notificationType==2">
            <div class="columns">
                <div class="column is-full">
                    <input class="input is-success" type="text" placeholder="Name" v-model="title">
                </div>
            </div>
            <div class="columns">
                <div class="column is-3">
                    <b-select id="restrictAwardBy" name="restrictAwardBy" v-model="restrictAwardBy">
                        <option selected value="1">Used by everyone</option>
                        <option value="2">Used only by class teachers</option>
                        <option value="3">Used only by selected teachers</option>
                    </b-select>
                </div>
                <div class="column is-5" v-show="restrictAwardBy == 3">
                    <multiselect v-model="restrictAwardTo" :options="listTeachers" :close-on-select="false" :multiple="true" :hide-selected="true" label="firstName" track-by="_id" placeholder="Teachers that can use this behavior"></multiselect>
                </div>
                <div class="column is-3">
                    <compact-picker v-model="colour" :palette="palette" />
                </div>
            </div>            
            <div class="columns">
                <div class="column is-full">
                    <input class="input is-success" type="text" placeholder="Optional details about this notification" v-model="info">
                </div>
            </div>
            <div class="columns">
                <div class="column is-3">
                    Is adding remarks mandatory?
                </div>
                <div class="column">                        
                    <b-radio v-model="isRemarksMandatory" native-value="1">
                        Yes
                    </b-radio>
                    <b-radio v-model="isRemarksMandatory" native-value="0">
                        No
                    </b-radio>
                </div>
            </div>
            <div class="columns">
                <div class="column is-3">
                    Status:
                </div>
                <div class="column">                        
                    <b-radio v-model="status" native-value="1">
                        Active
                    </b-radio>
                    <b-radio v-model="status" native-value="0">
                        Inactive
                    </b-radio>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column is-full">
                <button class='button is-primary  is-fullwidth' v-on:click="sendForm()">Submit</button>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import { ToastProgrammatic as Toast } from 'buefy'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { Compact } from 'vue-color'

export default {
    name: "ManageNotificationsAdd",
    components:{
        Multiselect,
        Loading,
        'compact-picker': Compact,
    },
    data() {
        return {
            notificationType: 1,
            title: '',
            message: '',
            repeatOn: [],
            repeatTime: 7,
            target: 1,   //for teacher app
            sendNow: 0,
            restrictAwardBy: 1,
            restrictAwardTo: [],
            info: "",
            isRemarksMandatory: 1,
            colour: '#0C4BF7',
            palette : ['#f3052c', '#ee15c3', '#b90bde','#8208f4','#1e08f4','#0898f4','#08ecf4','#08f498','#08f43f','#f5ed07','#f59e07','#f56007','#f52307','#000000'],
            status: 1,
            listTeachers: [],
            isLoading: false
        };
    },
    created() {
        this.getTeacherList();
    },
    methods: {
        getTeacherList(){
            let self = this;            
            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/teachers/list/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email')
            })
            .then(response => {
                self.listTeachers = response.data
            })
            .catch(e => {
                console.log(e)
            })
        },
        sendForm() {
            let self = this;

            var notificationType = self.notificationType

            if (notificationType == 1){                

                var title = self.title;
                var message = self.message;
                var repeatOn = self.repeatOn;

                if (title.length < 1){
                    Toast.open({
                        message: "Please enter the title for the notification",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 3000
                    })
                    return false;
                }else{
                    title = title.trim()
                }
                if (message.length < 1){
                    Toast.open({
                        message: "Please enter the message you want to send",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 3000
                    })
                    return false;
                }else{
                    message = message.trim()
                }

                if (self.sendNow == 1){

                    self.isLoading = true;

                    axios.defaults.responseType = 'json'
                    axios.post(process.env.NEW_ENDPOINT + '/notifications/send/', {
                        token: localStorage.getItem('jwtTokenV2'),
                        email: localStorage.getItem('email'),
                        title: title,
                        message: message,
                        target: self.target
                    })
                    .then(response => {
                        self.isLoading = false;
                        if (response.data.success == false) {
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        } else {
                            Toast.open({
                                color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                message: response.data.msg,
                                type: 'is-success',
                                duration: 3000
                            })

                            self.title = '';
                            self.message = '';
                            self.repeatOn = [];
                        }
                    })
                    .catch(e => {
                        self.isLoading = false;
                        console.log(e.response)
                        if (e.response.status === 401) {                            
                            Toast.open({
                                message: "Unauthorized access. Please re-login.",
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        } else {
                            Toast.open({
                                message: 'Error: ' + e.response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        }
                    })

                }else{
                    if (repeatOn.length < 1){
                        Toast.open({
                            message: "Please select the day(s) you want the notification to be sent",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 3000
                        })
                        return false;
                    }

                    self.isLoading = true;

                    axios.defaults.responseType = 'json'
                    axios.post(process.env.NEW_ENDPOINT + '/notifications/add/', {
                        token: localStorage.getItem('jwtTokenV2'),
                        email: localStorage.getItem('email'),
                        title: title,
                        message: message,
                        repeatOn: repeatOn,
                        repeatTime: self.repeatTime,
                        target: self.target,
                        status: self.status
                    })
                    .then(response => {
                        self.isLoading = false;
                        if (response.data.success == false) {
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        } else {
                            Toast.open({
                                color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                message: response.data.msg,
                                type: 'is-success',
                                duration: 3000
                            })

                            self.title = '';
                            self.message = '';
                            self.repeatOn = [];
                            self.$parent.getData()
                        }
                    })
                    .catch(e => {
                        self.isLoading = false;
                        console.log(e.response)
                        if (e.response.status === 401) {                            
                            Toast.open({
                                message: "Unauthorized access. Please re-login.",
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        } else {
                            Toast.open({
                                message: 'Error: ' + e.response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        }
                    })

                }

            }else{                

                var name = self.title;
                var restrictAwardBy = self.restrictAwardBy;
                var restrictAwardTo = self.restrictAwardTo;
                var colour = self.colour;
                var info = self.info;
                var isRemarksMandatory = self.isRemarksMandatory;
                var status = self.status;
                var selectedColour = "#0C4BF7";

                if ((!name) || (name.length < 1)){
                    Toast.open({
                        message: "Please enter the notification's name",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 3000
                    })
                    return false;
                }else{
                    name = name.trim()
                }
                
                if (restrictAwardBy == 3){
                    if ((!restrictAwardTo) || (restrictAwardTo.length < 1)){
                        Toast.open({
                            message: "Please select the teachers that can send this notification",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 3000
                        })
                        return false;
                    }
                }
                
                if (!colour.hex){
                    selectedColour = "#0C4BF7"
                }else{
                    selectedColour = colour.hex
                }
                self.isLoading = true;

                
                if (!status){
                    status = 1
                }else{
                    status = parseInt(status)
                }

                self.isLoading = true;

                axios.defaults.responseType = 'json'
                axios.post(process.env.NEW_ENDPOINT + '/behaviors/add/', {
                    token: localStorage.getItem('jwtTokenV2'),
                    email: localStorage.getItem('email'),
                    name: name,
                    points: 0,
                    dataType: 3,
                    restrictAwardBy: restrictAwardBy,
                    restrictAwardTo: restrictAwardTo,
                    maxDailyCountOverall: -1,
                    status: status,
                    colour: selectedColour,
                    info: info,
                    isMandatory: 0,
                    isRemarksMandatory: isRemarksMandatory,
                    sendNotification: 0,
                    enableFaceCapture: 0,
                    enableLocation: 0
                })
                .then(response => {
                    self.isLoading = false;
                    if (response.data.success == false) {
                        Toast.open({
                            message: response.data.msg,
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                    } else {
                        Toast.open({
                            color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            message: response.data.msg,
                            type: 'is-success',
                            duration: 3000
                        })
                    }

                    self.name = ""
                    self.restrictAwardBy = 1
                    self.restrictAwardTo = []
                    self.status = 1
                    self.info = ""
                    self.isRemarksMandatory = 0
                    self.$parent.getData2()
                })
                .catch(e => {
                    self.isLoading = false;
                    console.log(e.response)
                    if (e.response.status === 401) {                            
                        Toast.open({
                            message: "Unauthorized access. Please re-login.",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                    } else {
                        Toast.open({
                            message: 'Error: ' + e.response.data.msg,
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                    }
                })
            }
         
        },
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.myLabel{
    float: left;
    width: 15%;
    padding: 5px;
}
.myInput{
    float: left;
    width: 80%;
    padding: 5px;
}
.vertical-center{
    display: flex;
    align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Manage/Notifications/AddContent.vue